import React, { useState, useEffect } from 'react';
import { DashboardLayout } from '@blumtechgroup/blum-react-core-components';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { createLocationInitQuery, Organisation } from './queries';
import { useQuery } from '@apollo/client';
import { LocationCreateComponent } from '../../../../../components/Global';

type UrlParams = {
  organisation_id: string;
};

const LocationCreate = (): React.ReactElement => {
  const navigate = useNavigate();
  const routeState = useLocation();

  const { organisation_id } = useParams<UrlParams>();

  const [organisation, setOrganisation] = useState<Organisation>({
    name: '',
  });

  const { data: organisationInitData } = useQuery(createLocationInitQuery(organisation_id!), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (organisationInitData) {
      setOrganisation(organisationInitData.organisations_by_pk);
    }
  }, [organisationInitData]);

  const handleFinish = (locationId: string) => {
    navigate(`/admin/organisations/${organisation_id}/locations/${locationId}`, { state: routeState?.state });
  };

  return (
    <DashboardLayout
      breadcrumbs={[
        { label: 'Admin', link: '/admin/home' },
        { label: 'Organisations', link: '/admin/organisations' },
        { label: organisation.name, link: `/admin/organisations/${organisation_id}` },
        { label: 'Hospitals', link: `/admin/organisations/${organisation_id}/locations` },
        { label: 'Create' },
      ]}>
      <LocationCreateComponent name={routeState?.state?.locationName} organisationId={organisation_id!} handleFinish={handleFinish} />
    </DashboardLayout>
  );
};

export default LocationCreate;
